import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OrderSessionState {
  getStartedActivated: boolean;
  EditRequestTimeOutClicked: boolean;
  hasUserEditedOnce: boolean;
  timeoutCount: number;
  getStartedActiviatedForSpecific: boolean;
  getStartedActiviatedForReturned: boolean;
}

const initialState: OrderSessionState = {
  getStartedActivated: false,
  hasUserEditedOnce: false,
  EditRequestTimeOutClicked: false,
  timeoutCount: 0,
  getStartedActiviatedForSpecific: false,
  getStartedActiviatedForReturned: false,
};

const orderSessionStorageSlice = createSlice({
  name: "orderSessionStorage",
  initialState,
  reducers: {
    handleSetGetStartedActivated(state, action: PayloadAction<boolean>) {
      state.getStartedActivated = action.payload;
    },
    handleSetGetStartedActivatedForSpecific(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.getStartedActiviatedForSpecific = action.payload;
    },
    handleSetGetStartedActivatedForReturned(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.getStartedActiviatedForReturned = action.payload;
    },
    handleSetEditRequestTimeOutClicked(state, action: PayloadAction<boolean>) {
      state.EditRequestTimeOutClicked = action.payload;
    },
    handleSetTimeoutCount(state, action: PayloadAction<number>) {
      state.timeoutCount = action.payload;
    },
    handleSethasUserEditedOnce(state, action: PayloadAction<boolean>) {
      state.hasUserEditedOnce = action.payload;
    },
  },
});

export const {
  handleSetGetStartedActivated,
  handleSetEditRequestTimeOutClicked,
  handleSetTimeoutCount,
  handleSethasUserEditedOnce,
  handleSetGetStartedActivatedForSpecific,
  handleSetGetStartedActivatedForReturned,
} = orderSessionStorageSlice.actions;
export default orderSessionStorageSlice.reducer;
